import * as React from 'react'
import styled from 'styled-components'

import * as S from '../../styles'
import { RoleTagColors } from '../../styles/tag'

export type RoleTagProps = {
  backgroundColor?: RoleTagColors
} & React.HTMLAttributes<HTMLDivElement>

function RoleTagComponent({ children, backgroundColor, ...props }: RoleTagProps): React.ReactElement<RoleTagProps> {
  return (
    <S.tag.RoleTag backgroundColor={backgroundColor} {...props}>
      {children}
    </S.tag.RoleTag>
  )
}

export const RoleTag = styled(RoleTagComponent)<RoleTagProps>``
RoleTag.displayName = 'RoleTag'
